import {connect} from 'formik';

export const HolderTitle = connect(({formik}) => {
  return <h4>{I18n.t(`donate.holder_title.${formik.values.payment_method}`)}</h4>
})
